var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "message-content",
      attrs: { "data-cy": "message-content-page" },
    },
    [
      _c("div", { staticClass: "message-content-header" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.$t("smsRegistrations.messagingContentHeader"))),
        ]),
      ]),
      _c("div", { staticClass: "keywords-wrapper" }, [
        _c("h5", [
          _vm._v(
            _vm._s(_vm.$t("smsRegistrations.messagingContentCommandKeyWords"))
          ),
        ]),
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("smsRegistrations.messagingContentCommandKeyWordsInfo")
            ),
          },
        }),
        _c("div", { staticClass: "stop-box" }, [
          _c(
            "div",
            { staticClass: "stop-wrapper" },
            [
              _c("text-field", {
                staticClass: "stop-keyword",
                attrs: {
                  label: _vm.$t("smsRegistrations.stopKeyword"),
                  required: false,
                  readOnly: true,
                  value: "STOP,END,QUIT,CANCEL,UNSUBSCRIBE,REVOKE,OPT OUT",
                },
              }),
              _c("text-field", {
                staticClass: "stop-message",
                attrs: {
                  label: _vm.$t("smsRegistrations.stopMessage"),
                  readOnly: !_vm.messageContentDetails.stopMessageEditable,
                  disabled: _vm.readOnly,
                  value: _vm.messageContentDetails.stopMessage,
                  "validation-message": _vm.messagesMinLengthErrorMessage,
                  pattern: _vm.messageLengthRegex,
                  "data-cy": "content-stop-message",
                },
                on: {
                  textChanged: function ($event) {
                    _vm.messageContentDetails.stopMessage = $event
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "icons-wrapper" },
                [
                  _c("vwc-icon-button", {
                    staticClass: "edit-icon",
                    attrs: { disabled: _vm.readOnly, icon: "edit-line" },
                    on: { click: _vm.handleEditStop },
                  }),
                  _c("vwc-icon-button", {
                    staticClass: "reset-button",
                    attrs: {
                      icon: "reset-line",
                      disabled:
                        _vm.readOnly ||
                        !_vm.messageContentDetails.stopMessageEditable,
                    },
                    on: { click: _vm.handleResetStop },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "help-wrapper" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("smsRegistrations.messagingContentHelpInfo"))),
          ]),
          _c(
            "div",
            { staticClass: "support-inputs" },
            [
              _c("text-field", {
                attrs: {
                  placeholder: _vm.$t(
                    "smsRegistrations.messagingContentHelpSupportNumber"
                  ),
                  required: false,
                  disabled: _vm.readOnly,
                  "data-cy": "content-support-phone-number-input",
                  value: _vm.messageContentDetails.supportPhone,
                },
                on: {
                  textFieldFocusout: _vm.editHelpMessage,
                  textChanged: function ($event) {
                    _vm.messageContentDetails.supportPhone = $event
                  },
                },
              }),
              _c("text-field", {
                attrs: {
                  placeholder: _vm.$t(
                    "smsRegistrations.messagingContentHelpSupportEmail"
                  ),
                  required: false,
                  disabled: _vm.readOnly,
                  "data-cy": "content-support-email-input",
                  value: _vm.messageContentDetails.supportEmail,
                },
                on: {
                  textFieldFocusout: _vm.editHelpMessage,
                  textChanged: function ($event) {
                    _vm.messageContentDetails.supportEmail = $event
                  },
                },
              }),
              _c("text-field", {
                attrs: {
                  placeholder: _vm.$t(
                    "smsRegistrations.messagingContentHelpSupportUrl"
                  ),
                  required: false,
                  disabled: _vm.readOnly,
                  "data-cy": "content-support-url-input",
                  value: _vm.messageContentDetails.supportUrl,
                },
                on: {
                  textFieldFocusout: _vm.editHelpMessage,
                  textChanged: function ($event) {
                    _vm.messageContentDetails.supportUrl = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "help-info" },
            [
              _c("text-field", {
                staticClass: "help-keyword",
                attrs: {
                  label: _vm.$t("smsRegistrations.helpKeyword"),
                  required: false,
                  readOnly: true,
                  value: "HELP",
                },
              }),
              _c("text-field", {
                staticClass: "help-message",
                attrs: {
                  label: _vm.$t("smsRegistrations.helpMessage"),
                  value: _vm.messageContentDetails.helpMessage,
                  readOnly: !_vm.messageContentDetails.helpMessageEditable,
                  disabled: _vm.readOnly,
                  "validation-message": _vm.messagesMinLengthErrorMessage,
                  pattern: _vm.messageLengthRegex,
                  "data-cy": "content-help-message",
                },
                on: {
                  textChanged: function ($event) {
                    _vm.messageContentDetails.helpMessage = $event
                  },
                },
              }),
              _c(
                "div",
                { staticClass: "icons-wrapper" },
                [
                  _c("vwc-icon-button", {
                    staticClass: "edit-icon",
                    attrs: { disabled: _vm.readOnly, icon: "edit-line" },
                    on: { click: _vm.handleEditHelp },
                  }),
                  _c("vwc-icon-button", {
                    staticClass: "reset-button",
                    attrs: {
                      icon: "reset-line",
                      disabled:
                        _vm.readOnly ||
                        !_vm.messageContentDetails.helpMessageEditable,
                    },
                    on: { click: _vm.handleResetHelp },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "sample-messages" },
        [
          _c("h5", [_vm._v(_vm._s(_vm.$t("smsRegistrations.sampleMessages")))]),
          _c("sample-messages", {
            staticClass: "campaign-step",
            attrs: { slot: "step-body-4", "read-only": _vm.readOnly },
            slot: "step-body-4",
            model: {
              value: _vm.messageContentDetails.campaignSamples,
              callback: function ($$v) {
                _vm.$set(_vm.messageContentDetails, "campaignSamples", $$v)
              },
              expression: "messageContentDetails.campaignSamples",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }